import { ServiceMode } from 'state/service-mode/types';

export const serviceModeList = [
  ServiceMode.MOBILE_ORDER_DRIVE_THRU,
  ServiceMode.DRIVE_THRU,
  ServiceMode.TAKEOUT,
  ServiceMode.EAT_IN,
];
